import React, { useState } from "react";
import { NativeCouponStateI } from "../../PaymentPage.controller";
import {
  couponErrorMessage,
  couponPlanLines,
  couponRemovable,
} from "../../../../../../native/nativeCoupon";

interface NativeCouponProps extends NativeCouponStateI {
  translate: (key: string) => string;
}

/**
 * Cupón del pago native (cupones IT por anualidad): el cupón con el que va el
 * lead (el suyo o el de por defecto) con su plan por años, y la casilla para
 * cambiarlo mientras no esté congelado. Mismo marco que el chip/casilla de hoy.
 */
const NativeCoupon = ({
  view,
  error,
  busy,
  apply,
  remove,
  translate,
}: NativeCouponProps) => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");

  if (null === view) {
    return null;
  }

  const coupon = view.coupon;
  const planLines = couponPlanLines(view.plan);

  const handleApply = async () => {
    const code = input.trim();
    if (!code) return;
    if (await apply(code)) {
      setInput("");
      setOpen(false);
    }
  };

  return (
    <>
      {coupon && (
        <div className="paymentV3Summary__couponApplied">
          <span className="paymentV3Summary__couponAppliedLeft">
            <span className="paymentV3Summary__couponAppliedBadge">%</span>
            <span>
              <span className="paymentV3Summary__couponAppliedCode">
                {coupon.code}
              </span>
              {coupon.name && (
                <span className="paymentV3Summary__couponAppliedSub">
                  {coupon.name}
                </span>
              )}
              {coupon.description && (
                <span className="paymentV3Summary__couponAppliedDesc">
                  {coupon.description}
                </span>
              )}
              {planLines.length > 0 && (
                <ul className="paymentV3Summary__couponPlan">
                  {planLines.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              )}
            </span>
          </span>
          {couponRemovable(view) && (
            <button
              type="button"
              className="paymentV3Summary__couponRemove"
              onClick={remove}
              disabled={busy}
              aria-label={translate("paymentV3.summary.coupon.removeAria")}
            >
              ×
            </button>
          )}
        </div>
      )}

      {!view.redeemed && (
        <>
          <button
            type="button"
            className="paymentV3Summary__couponToggle"
            onClick={() => setOpen((o) => !o)}
          >
            <span>
              <span className="paymentV3Summary__couponToggleBadge">%</span>
              {translate("paymentV3.summary.coupon.cta")}
            </span>
            <span className="paymentV3Summary__couponToggleIcon">
              {open ? "−" : "+"}
            </span>
          </button>
          {open && (
            <div className="paymentV3Summary__couponInputRow">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value.toUpperCase())}
                placeholder={translate("paymentV3.summary.coupon.placeholder")}
                className="paymentV3Summary__couponInput"
              />
              <button
                type="button"
                onClick={handleApply}
                className="paymentV3Summary__couponApply"
                disabled={busy || !input.trim()}
              >
                {translate("paymentV3.summary.coupon.apply")}
              </button>
            </div>
          )}
        </>
      )}

      {error && (
        <div className="paymentV3Summary__couponError" role="alert">
          {couponErrorMessage(error)}
        </div>
      )}
    </>
  );
};

export default NativeCoupon;
